(() => {
  const init = (root) => {
    if (root.dataset.bpInitialized === 'true') return;
    root.dataset.bpInitialized = 'true';
    const data = JSON.parse(root.querySelector('[data-bp-variants]').textContent);
    const variants = new Map(data.variants.map((variant) => [String(variant.id), variant]));
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: data.currency || 'CAD' });
    const gallery = root.querySelector('[data-bp-gallery]');
    const slides = [...root.querySelectorAll('[data-bp-slide]')];
    const thumbs = [...root.querySelectorAll('[data-bp-thumbnail]')];
    const dots = [...root.querySelectorAll('[data-bp-dot]')];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reviewSection = root.querySelector('[data-bp-reviews]');
    root.querySelectorAll('[data-bp-review-link]').forEach((link) => link.addEventListener('click', (event) => {
      event.preventDefault();
      reviewSection.scrollIntoView({ behavior: reducedMotion ? 'instant' : 'smooth', block: 'start' });
      reviewSection.focus({ preventScroll: true });
    }));
    const reviewCards = [...root.querySelectorAll('[data-bp-review-card]')];
    const reviewMore = root.querySelector('[data-bp-review-more]');
    const reviewStatus = root.querySelector('[data-bp-review-status]');
    const updateReviewCount = () => {
      const shown = reviewCards.filter((card) => !card.hidden).length;
      if (reviewStatus) reviewStatus.textContent = reviewStatus.dataset.bpReviewStatusTemplate.replace('__BP_SHOWN__', String(shown)).replace('__BP_TOTAL__', String(reviewCards.length));
      if (reviewMore) reviewMore.hidden = shown >= reviewCards.length;
    };
    if (reviewMore) reviewMore.addEventListener('click', () => {
      const nextCards = reviewCards.filter((card) => card.hidden).slice(0, 3);
      nextCards.forEach((card) => { card.hidden = false; });
      updateReviewCount();
      if (reviewMore.hidden) nextCards[0]?.focus({ preventScroll: true });
    });
    document.addEventListener('shopify:block:select', (event) => {
      const index = reviewCards.findIndex((card) => card.dataset.bpReviewId === event.detail.blockId);
      if (index < 0) return;
      reviewCards.slice(0, index + 1).forEach((card) => { card.hidden = false; });
      updateReviewCount();
    });
    updateReviewCount();
    let activeImage = 0;
    const showImage = (index) => {
      activeImage = Math.max(0, Math.min(slides.length - 1, index));
      gallery.scrollTo({ left: slides[activeImage].offsetLeft - slides[0].offsetLeft, behavior: reducedMotion ? 'instant' : 'smooth' });
    };
    thumbs.forEach((button, index) => button.addEventListener('click', () => showImage(index)));
    root.querySelectorAll('[data-bp-gallery-direction]').forEach((button) => button.addEventListener('click', () => showImage(activeImage + Number(button.dataset.bpGalleryDirection))));
    gallery.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        showImage(activeImage + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    let galleryFrame;
    gallery.addEventListener('scroll', () => {
      cancelAnimationFrame(galleryFrame);
      galleryFrame = requestAnimationFrame(() => {
        activeImage = Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
        thumbs.forEach((button, index) => { button.classList.toggle('bp-active', index === activeImage); button.setAttribute('aria-current', String(index === activeImage)); });
        dots.forEach((dot, index) => dot.classList.toggle('bp-active', index === activeImage));
      });
    }, { passive: true });
    const packs = [...root.querySelectorAll('[data-bp-pack]')];
    const filters = [...root.querySelectorAll('[data-bp-gallery-filter]')];
    const portraitRail = root.querySelector('.bp-portrait-rail');
    filters.forEach((button) => button.addEventListener('click', () => {
      const design = button.dataset.bpGalleryFilter;
      filters.forEach((filter) => filter.setAttribute('aria-pressed', String(filter === button)));
      portraitRail.querySelectorAll('[data-bp-design]').forEach((figure) => { figure.hidden = design !== 'all' && figure.dataset.bpDesign !== design; });
      portraitRail.scrollTo({ left: 0, behavior: 'instant' });
    }));
    const selectedPack = () => packs.find((pack) => pack.querySelector('input[type="radio"]').checked);
    const extras = [...root.querySelectorAll('[data-bp-extra]')];
    const selectedExtras = () => extras.filter((input) => input.checked && !input.disabled);
    const normalizeVariantTitle = (title) => String(title || '').split('/').map((part) => part.trim().toLowerCase()).join(' / ');
    const priceVariant = (pack) => {
      const selected = variants.get(pack.querySelector('[data-bp-variant]')?.value);
      if (selected) return selected;
      const draftPair = pack.querySelector('.bp-draft-pair');
      const color = draftPair?.querySelector('[data-bp-draft-color]')?.value;
      const size = draftPair?.querySelector('[data-bp-draft-size]')?.value;
      const title = normalizeVariantTitle(`${color} / ${size}`);
      return data.variants.find((variant) => normalizeVariantTitle(variant.title) === title) || variants.get(String(data.default_variant_id)) || data.variants[0];
    };
    const updatePrices = () => {
      const extraAmount = selectedExtras().reduce((total, input) => total + Number(input.dataset.bpExtraPrice), 0);
      packs.forEach((pack) => {
        const count = Number(pack.dataset.bpPack);
        const base = priceVariant(pack);
        const actualAmount = count === 1 ? base?.price : data.bundles[count]?.price;
        const amount = actualAmount != null ? actualAmount : Number(pack.dataset.bpPreviewPrice);
        pack.querySelector('[data-bp-pack-price]').textContent = money.format(amount / 100);
        if (pack === selectedPack()) {
          const total = money.format((amount + extraAmount) / 100);
          root.querySelector('[data-bp-sticky-price]').textContent = total;
          root.querySelector('[data-bp-order-total]').textContent = total;
          if (base) {
            root.querySelector('[data-bp-unit-price]').textContent = base.formatted;
            const compare = root.querySelector('[data-bp-compare-price]');
            const sale = root.querySelector('[data-bp-sale-pill]');
            const discounted = base.compare_price > base.price;
            compare.hidden = !discounted;
            sale.hidden = !discounted;
            if (discounted) {
              compare.textContent = base.compare_formatted;
              sale.textContent = data.sale_template.replace('__BP_PERCENT__', Math.round((base.compare_price - base.price) * 100 / base.compare_price));
            }
          }
        }
      });
    };
    const selectPack = () => {
      packs.forEach((pack) => {
        const active = pack === selectedPack();
        pack.classList.toggle('bp-active', active);
        pack.querySelector('.bp-pack-options').hidden = !active;
        pack.querySelectorAll('select').forEach((select) => { select.disabled = !active; });
      });
      updatePrices();
    };
    packs.forEach((pack) => {
      pack.querySelector('input[type="radio"]').addEventListener('change', selectPack);
      pack.querySelectorAll('[data-bp-variant], [data-bp-draft-color], [data-bp-draft-size]').forEach((select) => select.addEventListener('change', updatePrices));
    });
    extras.forEach((input) => input.addEventListener('change', () => {
      input.closest('.bp-paid-offer').classList.toggle('bp-selected', input.checked);
      updatePrices();
    }));
    selectPack();
    root.querySelectorAll('[data-bp-draft-color]').forEach((select) => select.addEventListener('change', () => showImage(['Red', 'Green', 'White'].indexOf(select.value) + 1)));
    root.querySelectorAll('[data-bp-unit]').forEach((button) => button.addEventListener('click', () => {
      const unit = button.dataset.bpUnit;
      root.querySelectorAll('[data-bp-unit]').forEach((control) => control.setAttribute('aria-pressed', String(control.dataset.bpUnit === unit)));
      root.querySelectorAll('[data-bp-in]').forEach((cell) => { cell.textContent = unit === 'cm' ? cell.dataset.bpCm : cell.dataset.bpIn; });
      root.querySelectorAll('[data-bp-unit-label]').forEach((label) => { label.textContent = unit === 'cm' ? root.dataset.bpCentimetres : root.dataset.bpInches; });
    }));
    const dialog = root.querySelector('[data-bp-size-dialog]');
    root.querySelectorAll('[data-bp-size-open]').forEach((button) => button.addEventListener('click', () => dialog.showModal()));
    dialog.querySelector('[data-bp-size-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
    const imageDialog = root.querySelector('[data-bp-image-dialog]');
    if (imageDialog) {
      root.querySelectorAll('[data-bp-image-open]').forEach((button) => button.addEventListener('click', () => imageDialog.showModal()));
      imageDialog.querySelector('[data-bp-image-close]').addEventListener('click', () => imageDialog.close());
      imageDialog.addEventListener('click', (event) => {
        if (event.target !== imageDialog) return;
        const rect = imageDialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) imageDialog.close();
      });
    }
    const goToOptions = () => {
      root.querySelector('.bp-packs').scrollIntoView({ behavior: reducedMotion ? 'instant' : 'smooth', block: 'center' });
      selectedPack().querySelector('input[type="radio"]').focus({ preventScroll: true });
    };
    root.querySelectorAll('[data-bp-to-options]').forEach((button) => button.addEventListener('click', goToOptions));
    const status = root.querySelector('[data-bp-status]');
    const purchase = root.querySelector('[data-bp-purchase]');
    const cartLink = root.querySelector('[data-bp-cart-link]');
    const refreshCartCount = async () => {
      try {
        const response = await fetch(root.dataset.bpCartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', signal: AbortSignal.timeout(5000) });
        if (!response.ok) return;
        const cart = await response.json();
        if (!Number.isInteger(cart.item_count) || cart.item_count < 0) return;
        document.querySelectorAll('[data-bp-cart-count]').forEach((badge) => {
          badge.textContent = String(cart.item_count);
          badge.hidden = cart.item_count === 0;
        });
      } catch {}
    };
    let pending = false;
    const purchaseButtons = [...root.querySelectorAll('[data-bp-add], [data-bp-sticky-add]')];
    const addToCart = async () => {
      if (pending) return;
      cartLink.hidden = true;
      status.dataset.error = 'false';
      if (root.dataset.bpEnabled !== 'true') {
        status.dataset.error = 'true';
        status.textContent = root.dataset.bpOrderingUnavailable;
        purchase.scrollIntoView({ behavior: reducedMotion ? 'instant' : 'smooth', block: 'center' });
        return;
      }
      const selections = [...selectedPack().querySelectorAll('[data-bp-variant]')];
      if (!selections.length || selections.some((select) => !variants.get(select.value)?.available)) {
        status.dataset.error = 'true';
        status.textContent = root.dataset.bpUnavailable;
        return;
      }
      const count = Number(selectedPack().dataset.bpPack);
      const items = [];
      if (count > 1) {
        const bundle = data.bundles[count];
        if (!bundle?.id || !bundle.available) {
          status.dataset.error = 'true';
          status.textContent = data.bundle_missing;
          return;
        }
        const properties = {};
        selections.forEach((select, index) => { properties[`${data.pair_label} ${index + 1}`] = variants.get(select.value).title; });
        items.push({ id: Number(bundle.id), quantity: 1, properties });
      } else {
        items.push({ id: Number(selections[0].value), quantity: 1 });
      }
      const chosenExtras = selectedExtras().map((input) => data.extras[input.dataset.bpExtra]);
      if (chosenExtras.some((extra) => !extra?.id || !extra.available)) {
        status.dataset.error = 'true';
        status.textContent = data.extra_missing;
        return;
      }
      chosenExtras.forEach((extra) => items.push({ id: Number(extra.id), quantity: 1 }));
      pending = true;
      purchaseButtons.forEach((button) => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
      status.textContent = root.dataset.bpWorking;
      try {
        const response = await fetch(root.dataset.bpAddUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items }) });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || root.dataset.bpError);
        status.textContent = root.dataset.bpAdded;
        cartLink.hidden = false;
        document.dispatchEvent(new CustomEvent('bp:cart-updated', { detail: result }));
        purchase.scrollIntoView({ behavior: reducedMotion ? 'instant' : 'smooth', block: 'center' });
        await refreshCartCount();
      } catch (error) {
        status.dataset.error = 'true';
        status.textContent = error.message || root.dataset.bpError;
        purchase.scrollIntoView({ behavior: reducedMotion ? 'instant' : 'smooth', block: 'center' });
      } finally {
        pending = false;
        purchaseButtons.forEach((button) => { button.disabled = false; button.removeAttribute('aria-busy'); });
      }
    };
    purchaseButtons.forEach((button) => button.addEventListener('click', addToCart));
    const sticky = root.querySelector('[data-bp-sticky]');
    let stickyFrame;
    const updateSticky = () => { sticky.hidden = purchase.getBoundingClientRect().bottom > 0; root.classList.toggle('bp-has-sticky', !sticky.hidden); };
    window.addEventListener('scroll', () => { cancelAnimationFrame(stickyFrame); stickyFrame = requestAnimationFrame(updateSticky); }, { passive: true });
    updateSticky();
  };
  const initAll = () => document.querySelectorAll('[data-bp-product]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();